import { Card } from "@/components/ui/card";
import { FileText, GraduationCap } from "lucide-react";
import NoteMediaGallery from "@/components/NoteMediaGallery";
import { formatTRDate, mediaSrc } from "./shared";

export default function NotesView({ notes }) {
  return (
    <div data-testid="parent-notes">
      <h1 className="font-heading text-2xl font-bold text-slate-900">Ders Notları</h1>
      <p className="mt-1 text-sm text-slate-500">Öğretmeninizin paylaştığı günlük gelişim notları ve medyalar.</p>

      <div className="mt-5 space-y-4">
        {notes.map((n) => (
          <Card
            key={n.id}
            data-testid={`parent-note-${n.id}`}
            className="overflow-hidden rounded-2xl border-slate-200/60 shadow-[0_2px_10px_rgba(0,0,0,0.04)]"
          >
            <div className="border-b border-slate-100 bg-gradient-to-r from-violet-50/80 to-white px-4 py-3 sm:px-5">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <p className="text-sm font-bold text-violet-700">{formatTRDate(n.date)}</p>
                {n.student_name && (
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-slate-500">
                    <GraduationCap className="h-3.5 w-3.5" />
                    {n.student_name}
                  </span>
                )}
              </div>
            </div>

            <div className="space-y-3 p-4 sm:p-5">
              {n.content && (
                <p className="whitespace-pre-wrap text-[15px] leading-relaxed text-slate-800">{n.content}</p>
              )}
              <NoteMediaGallery
                mediaUrls={n.media_urls}
                resolveUrl={mediaSrc}
                testIdPrefix={`parent-note-${n.id}`}
              />
              {!n.content && !n.media_urls?.length && (
                <p className="text-sm text-slate-400">Not içeriği yok.</p>
              )}
            </div>
          </Card>
        ))}

        {notes.length === 0 && (
          <Card className="rounded-2xl border-dashed p-14 text-center text-slate-400">
            <FileText className="mx-auto mb-3 h-9 w-9 text-slate-300" />
            Henüz not yok.
          </Card>
        )}
      </div>
    </div>
  );
}
